// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"gV-z","categoryName":"hV-z","categoryNameSearchHeader":"iV-z","categoryContent":"jV-z","bottomAligned":"kV-z","image":"lV-z","imageNoBackground":"mV-z"};